<template>
  <div class='indexbox'>
    <div class="searchbox">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><a href="user">{{$t('lg.用户')}}</a></el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('lg.权限')}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button class="download" type="primary" :loading='loadinga' @click="confirm">{{$t('lg.保存')}}</el-button>
    </div>
    <div class="tablebox" v-loading='loading'>
      <div class="bodybox">
        <div class="topbox">
          <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll($event)">{{$t('lg.全选')}} / {{$t('lg.全不选')}}</el-checkbox>
        </div>
        <el-tree ref="menu" :default-checked-keys='rules' :data="rulelist" default-expand-all show-checkbox node-key="id" :props="defaultProps"></el-tree>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    data() {
      return {
        id: this.$route.query.id,
        rulelist: [
          {
            id: 100,
            title: "OMS",
            children: [],
          }
        ],
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        menuNodeAll: false,
        rules: [],
        loading: false,
        loadinga: false,
        lang: this.$i18n.locale,
      };
    },
    computed: {
      ...mapGetters(['api_id']),
    },
    created() {
      if (this.lang == 'zh') {
        this.defaultProps.label = 'title';
      } else {
        this.defaultProps.label = 'name';
      }
      this.getruleList()
    },
    methods: {
      getruleList() {
        this.loading = true
        this.$post({
          url: "/app/api_user/ruleList",
          data: {
            api_id: this.api_id
          },
          success: (res) => {
            // this.rulelist[0].children = res.data
            let dataa = {
              id: 100,
              title: this.$t('lg.店铺'),
              name: this.$t('lg.店铺'),
              children: [],
            }
            let datab = {
              id: 200,
              title: this.$t('lg.商品匹配'),
              name: this.$t('lg.商品匹配'),
              children: [],
            }
            let datac = {
              id: 300,
              title: this.$t('lg.订单同步'),
              name: this.$t('lg.订单同步'),
              children: [],
            }
            let datad = {
              id: 400,
              title: this.$t('lg.操作日志'),
              name: this.$t('lg.操作日志'),
              children: [],
            }
            let datae = {
              id: 500,
              title: this.$t('lg.设置'),
              name: this.$t('lg.设置'),
              children: [],
            }
            res.data.forEach(item => {
              if (item.cate == 1) {
                dataa.children.push(item)
              } else if (item.cate == 2) {
                datab.children.push(item)
              } else if (item.cate == 3) {
                datac.children.push(item)
              } else if (item.cate == 4) {
                datad.children.push(item)
              } else if (item.cate == 5) {
                datae.children.push(item)
              }
            });
            this.rulelist = [dataa, datab, datac, datad, datae]
            console.log(12, this.rulelist);
            this.getuser()
            setTimeout(() => {
              this.loading = false
            }, 200);
          },
          tip: () => {
            this.loading = false
          },
        })
      },
      getuser() {
        this.$post({
          url: "/app/api_user/info",
          data: {
            api_id: this.api_id,
            id: this.id,
          },
          success: (res) => {
            if (res.data.rules) {
              this.rules = res.data.rules.split(',')
            }
          },
          tip: () => {
          },
        })
      },
      // 树权限（全选/全不选）
      handleCheckedTreeNodeAll(value) {
        this.$refs.menu.setCheckedNodes(value ? this.rulelist : []);
      },
      // 所有部门节点数据
      getDeptAllCheckedKeys() {
        let checkedKeys = this.$refs.menu.getCheckedKeys();
        let halfCheckedKeys = this.$refs.menu.getHalfCheckedKeys();
        checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
        return checkedKeys;
      },
      confirm() {
        this.loadinga = true
        this.loading = true
        let checkedKeys = this.$refs.menu.getCheckedKeys();
        checkedKeys.map(item => {
          if (item > 99) {
            checkedKeys.splice(checkedKeys.indexOf(item), 1)
          }
        })
        this.$post({
          url: "/app/api_user/editRule",
          data: {
            api_id: this.api_id,
            id: this.id,
            rules: checkedKeys.join(),
          },
          success: (res) => {
            this.$notify({
              title: 'Success',
              type: 'success'
            });
            this.$router.go(0)
          },
          tip: () => {
            setTimeout(() => {
              this.loading = false
              this.loadinga = false
            }, 1500);
          },
        })
      }
    },
  }
</script>
<style lang='scss' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .searchbox {
      width: 100%;
      padding: 20px 30px;
      background: #fff;
      border-bottom: 1px solid #babdcd;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .tablebox {
      width: 100%;
      padding: 20px;
      .bodybox {
        width: 100%;
        padding: 20px 10px;
        background: #fff;
        .topbox {
          width: 100%;
          padding: 0 10px 20px;
          font-weight: 550;
        }
        /deep/.el-tree {
          > .el-tree-node {
            > .el-tree-node__content {
              font-weight: 550;
            }
          }
        }
      }
    }
  }
</style>